export type DirecaoOrdenacao = "asc" | "desc";

const colator = new Intl.Collator("pt-BR", { sensitivity: "base", numeric: true });

export const ordenarPorDescricao = <T extends { descricao?: string }>(
    itens: T[],
    direcao: DirecaoOrdenacao = "asc"
): T[] => {
    return [...itens].sort((a, b) => {
        const comparacao = colator.compare(a?.descricao ?? "", b?.descricao ?? "");
        return direcao === "asc" ? comparacao : comparacao * -1;
    });
}
